(function () {
  var sections = document.querySelectorAll('[data-hcine-section]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var hasHover = window.matchMedia('(hover: hover)').matches;

    if (hasHover) {
      section.addEventListener('pointermove', function (event) {
        var rect = section.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        section.style.setProperty('--hc-x', x + '%');
        section.style.setProperty('--hc-y', y + '%');
      });
    }

    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-revealed');
              revealObserver.unobserve(section);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealObserver.observe(section);
    } else {
      section.classList.add('is-revealed');
    }

    var parallaxEl = section.querySelector('[data-hcine-parallax]');
    if (!parallaxEl || reduceMotion) return;

    var ticking = false;

    function updateParallax() {
      var rect = section.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var progress = (rect.top + rect.height / 2 - viewportH / 2) / (viewportH / 2 + rect.height / 2);
      progress = Math.max(-1, Math.min(1, progress));
      var maxShift = 36;
      var shift = progress * maxShift * -1;
      parallaxEl.style.transform = 'translate3d(0, ' + shift.toFixed(1) + 'px, 0)';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    updateParallax();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  });
})();
